import React from 'react';
import {
  Umbrella as DailyRainIcon,
  Nature as EtoIcon,
  Opacity as HumidityIcon,
  TrendingUp as MaxTemperatureIcon,
  TrendingDown as MinTemperatureIcon,
  Grain as RainHourIcon,
  WbSunny as SolarRadiationIcon,
  DeviceThermostat as TemperatureIcon,
  Navigation as WindDirectionIcon,
  Air as WindIcon,
} from '@mui/icons-material/';

export interface WeatherDataItemProps {
  icon: React.ReactNode;
  label: string;
  value: number | null;
  unit?: string;
}

export const weatherDataConfig = [
  {
    key: 'windSpeed',
    label: 'Velocidad viento',
    icon: <WindIcon fontSize='medium' />,
    unit: ' Km/h',
  },
  {
    key: 'windDirection',
    label: 'Dirección viento',
    icon: <WindDirectionIcon fontSize='medium' />,
  },
  {
    key: 'solarRadiation',
    label: 'Radiación solar',
    icon: <SolarRadiationIcon fontSize='medium' />,
  },
  {
    key: 'humidity',
    label: 'Humedad ambiente',
    icon: <HumidityIcon fontSize='medium' />,
    unit: ' %',
  },
  {
    key: 'temperature',
    label: 'Temperatura ambiente',
    icon: <TemperatureIcon fontSize='medium' />,
    unit: '°C',
  },
  {
    key: 'maxTemperature',
    label: 'Temperatura máxima',
    icon: <MaxTemperatureIcon fontSize='medium' />,
    unit: '°C',
  },
  {
    key: 'minTemperature',
    label: 'Temperatura mínima',
    icon: <MinTemperatureIcon fontSize='medium' />,
    unit: '°C',
  },
  {
    key: 'dailyRain',
    label: 'Lluvia día',
    icon: <DailyRainIcon fontSize='medium' />,
    unit: ' mm',
  },
  {
    key: 'hourlyRain',
    label: 'Lluvia hora',
    icon: <RainHourIcon fontSize='medium' />,
    unit: ' mm',
  },
  {
    key: 'eto',
    label: 'Eto día',
    icon: <EtoIcon fontSize='medium' />,
  },
];
